import { render, staticRenderFns } from "./navbar-router-group.vue?vue&type=template&id=db2f5e3a"
import script from "./navbar-router-group.vue?vue&type=script&lang=js"
export * from "./navbar-router-group.vue?vue&type=script&lang=js"
import style0 from "./navbar-router-group.vue?vue&type=style&index=0&id=db2f5e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./navbar-router-group.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports